/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { dimensionStyle } from './themes/PieChartStyles.css';
import { TrackResizeContainer } from '#UNSAFE_TrackResizeContainer';
import { PieChartWithDimensions } from './PieChartWithDimensions';
import type { PieChartItemData, PieChartProps } from './pieChart.types';

/**
 * Pie charts are useful for visualizing parts of a whole, but do not display zero or negative values so they are not recommended for data sets that may have negative or null data
 */
export function PieChart<
  K extends string | number,
  D extends PieChartItemData<K> = PieChartItemData<K>
>({ width, height, ...props }: PieChartProps<K, D>) {
  return (
    <TrackResizeContainer width={width} height={height} class={dimensionStyle}>
      {(w, h) =>
        (
          <PieChartWithDimensions width={w} height={h} {...props} />
        )
      }
    </TrackResizeContainer>
  );
}
